import React from "react";

import Rating from "@mui/material/Rating";

import "./score.scss";

const Score = ({ score, tiny, onlyStars }) => {
  let scoreText = "";

  if (0 < score && score < 6) {
    scoreText = "Malo";
  } else if (5 < score && score < 8) {
    scoreText = "Bueno";
  } else if (7 < score && score < 10) {
    scoreText = "Muy Bueno";
  } else {
    scoreText = "Excelente";
  }

  return (
    <div
      className={`score__container ${tiny ? "tiny" : ""} ${
        onlyStars ? "onlyStars" : ""
      }`}
    >
      <div className="score__rating">
        <span>{scoreText}</span>
        <Rating
          className="score__stars"
          value={score / 2}
          precision={0.5}
          readOnly
        />
      </div>
      <div className="score__value">{score}</div>
    </div>
  );
};

export default Score;
